import React from 'react'
import { Icon } from '../../atoms/Icon'
import { AnalysisTabButtonMenuProps } from './AnalysisTabButtonMenu.types'
import {
  TabsContainer,
  TabButton,
  TabBadge,
} from './AnalysisTabButtonMenu.styles'

export const AnalysisTabButtonMenu: React.FC<AnalysisTabButtonMenuProps> = ({
  tabs,
  activeTab,
  onTabChange,
  className,
  style,
}) => {
  const handleTabClick = (tab: (typeof tabs)[0]) => {
    if (!tab.disabled) {
      onTabChange(tab.id)
    }
  }

  return (
    <TabsContainer className={className} style={style}>
      {tabs.map((tab) => (
        <TabButton
          key={tab.id}
          $active={activeTab === tab.id}
          $disabled={tab.disabled}
          onClick={() => handleTabClick(tab)}
        >
          <Icon name={tab.icon as any} size="small" />
          {tab.label}
          {tab.count !== undefined && <TabBadge>{tab.count}</TabBadge>}
        </TabButton>
      ))}
    </TabsContainer>
  )
}

AnalysisTabButtonMenu.displayName = 'AnalysisTabButtonMenu'
